import React, { useEffect, useState } from 'react';
import { catalogAPI } from './resellerapi';

export const ResellCatalog = ({ user }) => {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('categories'); 
  const [activeCategory, setActiveCategory] = useState(null); 
  const [error, setError] = useState(null); 

  useEffect(() => {
    const initLoad = async () => {
      try {
        setLoading(true);
        const catRes = await catalogAPI.getCategories();
        // Handle different possible response structures
        const data = catRes.data || catRes.categories || catRes || [];
        setCategories(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Category Load Error:", e);
        setError("Could not load categories. Check if api/reseller/categories exists.");
      } finally {
        setLoading(false);
      }
    };
    initLoad();
  }, []);

  const handleCategoryClick = async (cat) => {
    setLoading(true);
    setError(null);
    setActiveCategory(cat); 
    try {
      // FIX: Changed cat.name to cat.id so the server gets a number, not a string
      const prodRes = await catalogAPI.getProducts(cat.id); 
      
      const prodData = prodRes.products || prodRes.data || prodRes || [];
      setProducts(Array.isArray(prodData) ? prodData : []);
      
      setView('products'); 
    } catch (e) {
      setError("Failed to load products. Check server route: api/catalog");
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px', color: '#fff' }}>
        <div className="loading-spinner">Loading ATR Mart Catalog...</div>
      </div>
    );
  }

  return (
    <div className="resell-catalog-wrapper" style={{ padding: '20px' }}>
      
      {error && (
        <div style={{ backgroundColor: 'rgba(255,0,0,0.1)', border: '1px solid red', color: 'red', padding: '15px', borderRadius: '8px', marginBottom: '20px' }}>
          ⚠️ <b>Server Error:</b> {error}
        </div>
      )}
      
      <div className="catalog-header-nav" style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '30px' }}>
        {view === 'products' && (
          <button 
            onClick={() => setView('categories')} 
            style={{ cursor: 'pointer', padding: '10px 20px', borderRadius: '8px', border: '1px solid #444', background: '#333', color: '#fff' }}
          >
            ← Back to Categories
          </button>
        )}
        <h2 style={{ color: '#fff', fontSize: '24px', margin: 0 }}>
          {view === 'categories' ? 'Browse Categories' : `Catalog: ${activeCategory?.name}`}
        </h2>
      </div>

      {/* VIEW 1: CATEGORIES GRID */}
      {view === 'categories' && (
        <div 
          className="category-grid" 
          style={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
            gap: '20px', 
            width: '100%'
          }}
        >
          {categories.length > 0 ? (
            categories.map(cat => (
              <div 
                key={cat.id} 
                className="category-card-item" 
                onClick={() => handleCategoryClick(cat)} 
                style={{ 
                  cursor: 'pointer', 
                  textAlign: 'center', 
                  background: '#1a1a1a', 
                  border: '1px solid #333', 
                  padding: '20px', 
                  borderRadius: '15px',
                  transition: 'transform 0.2s'
                }}
              >
                {cat.icon && (cat.icon.includes('.') || cat.icon.length > 10) ? (
                  <img 
                    src={`https://atrmart.in/storage/categories/${cat.icon}`} 
                    alt={cat.name}
                    style={{ width: '80px', height: '80px', objectFit: 'contain', marginBottom: '15px' }} 
                    onError={(e) => { e.target.onerror = null; e.target.src = 'https://atrmart.in/assets/img/no-image.png'; }}
                  />
                ) : (
                  <div style={{ fontSize: '50px', marginBottom: '15px' }}>
                    {cat.icon || '📦'} 
                  </div>
                )}
                <p style={{ fontWeight: 'bold', color: '#fff', fontSize: '1.1rem' }}>{cat.name}</p>
              </div>
            ))
          ) : (
            <p style={{ color: '#888' }}>No categories available.</p>
          )}
        </div>
      )}

      {/* VIEW 2: PRODUCTS GRID */}
      {view === 'products' && (
        <div className="catalog-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '25px' }}>
          {products.length > 0 ? (
            products.map(p => {
              const profit = (p.resell_price || 0) - (p.price || 0); 
              return (
                <div key={p.id} style={{ background: '#1a1a1a', border: '1px solid #333', borderRadius: '15px', overflow: 'hidden' }}>
                  <img 
                    src={p.image ? `https://atrmart.in/storage/products/${p.image}` : 'https://atrmart.in/assets/img/no-image.png'} 
                    alt={p.name} 
                    style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                    onError={(e) => { e.target.onerror = null; e.target.src = 'https://atrmart.in/assets/img/no-image.png'; }}
                  />
                  <div style={{ padding: '20px' }}>
                    <h3 style={{ color: '#fff', marginBottom: '10px' }}>{p.name}</h3>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                      <span style={{ color: '#ccc' }}>Price: ₹{p.resell_price || p.price}</span>
                      <span style={{ color: '#4caf50', fontWeight: 'bold' }}>Profit: ₹{profit}</span>
                    </div>
                    <button style={{ width: '100%', padding: '12px', borderRadius: '10px', background: '#25D366', color: 'white', border: 'none', fontWeight: 'bold', cursor: 'pointer' }}>
                      📲 Share on WhatsApp
                    </button>
                  </div>
                </div>
              );
            })
          ) : (
            <div style={{ gridColumn: '1/-1', textAlign: 'center', color: '#888', padding: '50px' }}>
              No products available in this category.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ResellCatalog;